import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Loader from "../BaseFile/comman/Loader";
import {
  getTransactionById,
  clearErrors,
  clearMessage,
} from "../redux/transactionSlice";

export default function TradeTransaction() {
  const table_name = "roi_transaction";
  const fit = "Invest";
  const dispatch = useDispatch();

  const { auth } = useSelector((state) => state.auth);
  const { transaction, loading, error, message } = useSelector(
    (state) => state.transaction
  );

  // State for pagination
  const [currentPage, setCurrentPage] = useState(1);
  const entriesPerPage = 20;

  // Calculate total pages
  const totalPages = Math.ceil(transaction?.length / entriesPerPage);

  // Get current transactions to display
  const currentTransactions = transaction
    ?.slice()
    .reverse()
    .slice((currentPage - 1) * entriesPerPage, currentPage * entriesPerPage);

  useEffect(() => {
    if (table_name && auth?.id) {
      const user_id = auth?.id;
      dispatch(getTransactionById({ table_name, user_id }));
    }
    if (error) {
      const errorInterval = setInterval(() => {
        dispatch(clearErrors());
      }, 3000);
      return () => clearInterval(errorInterval);
    }
    if (message) {
      const messageInterval = setInterval(() => {
        dispatch(clearMessage());
      }, 3000);
      return () => clearInterval(messageInterval);
    }
  }, [dispatch, table_name, auth?.id]);

  // Pagination handlers
  const goToNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <>
      <Loader isLoading={loading} />
      <div className="m-3 p-4 bg-white">
        <div className="flex-col mb-4">
          <div className="mb-4">
            <h3 className="text-lg font-semibold text-slate-800">
              Transaction History
            </h3>
            <p className="text-lg text-slate-700">
              Overview of the Transaction History.
            </p>
          </div>

          <div className="relative flex w-full gap-5">
            <div className="relative w-full">
              <input
                id="search"
                name="search"
                className="w-full h-10 py-2 pl-3 text-lg transition duration-200 border rounded shadow-sm text-gray-100 bg-white border-gray-300 pr-11 placeholder:text-slate-700 ease focus:outline-none focus:border-slate-400 focus:shadow-md"
                placeholder="Search for transaction..."
              />
              <button
                className="absolute flex items-center w-8 h-8 px-2 my-auto rounded right-1 top-1"
                type="button"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="3"
                  stroke="currentColor"
                  className="w-6 h-6 text-gray-800"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div className="relative flex flex-col w-full h-full mb-4 text-gray-300 bg-clip-border">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left border table-auto min-w-max text-gray-900 bg-white">
                  <thead className="text-gray-200 bg-black">
                    <tr>
                      <th className="p-4 border border-gray-300">SR No</th>
                      <th className="p-4 border border-gray-300">Returns</th>
                      <th className="p-4 border border-gray-300">Currency</th>
                      <th className="p-4 border border-gray-300">Type</th>
                      <th className="p-4 border border-gray-300">On Amount</th>
                      <th className="p-4 border border-gray-300">
                        Company profit
                      </th>
                      <th className="p-4 border border-gray-300">
                        Description
                      </th>
                      <th className="p-4 border border-gray-300">Status</th>
                      <th className="p-4 border border-gray-300">
                        Transaction By
                      </th>
                      <th className="p-4 border border-gray-300">Created At</th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {(fit
                      ? currentTransactions?.filter((item) =>
                          item?.type?.includes(fit)
                        )
                      : currentTransactions
                    )?.length > 0 ? (
                      (fit
                        ? currentTransactions?.filter((item) =>
                            item?.type?.includes(fit)
                          )
                        : currentTransactions
                      )?.map((item, index) => (
                        <tr
                          key={index}
                          className="text-gray-800 even:bg-[#e3e3e3] even:text:white"
                        >
                          <td className="py-4 pl-4 pr-3 border whitespace-nowrap sm:pl-3">
                            {(currentPage - 1) * entriesPerPage + index + 1}
                          </td>

                          <td className="py-4 pl-4 pr-3 border whitespace-nowrap sm:pl-3">
                            ${item?.amount}
                          </td>
                          <td className="px-3 py-4 border whitespace-nowrap">
                          {item?.currency === "USD" ? "USDT" : item?.currency || "USDT"}
                          </td>
                          <td className="px-3 py-4 border  capitalize whitespace-nowrap">
                            Trade Income
                          </td>
                          <td className="px-3 py-4 border  whitespace-nowrap">
                            {item?.onamount}
                          </td>
                          <td className="px-3 py-4 border whitespace-nowrap">3%</td>
                          <td className="px-3 py-4 border  whitespace-nowrap max-w-xs truncate">
                            {item?.description || "-"}
                          </td>
                          <td className="px-3 py-4 border whitespace-nowrap">
                            <span
                              className={`px-2 py-1  bg-green-100 text-green-800 font-semibold rounded-full `}
                            >
                              credit
                            </span>
                            {/* <span
                              className={`px-2 py-1 text-xs font-semibold rounded-full ${
                                item?.status === 'Completed' || item?.status === 'Success'
                                  ? 'bg-green-100 text-green-800'
                                  : item?.status === 'Pending'
                                  ? 'bg-yellow-100 text-yellow-800'
                                  : item?.status === 'Failed'
                                  ? 'bg-red-100 text-red-800'
                                  : 'bg-gray-100 text-gray-800'
                              }`}
                            >
                              {item?.status || 'Pending'}
                            </span> */}
                          </td>
                          <td className="px-3 py-4 border whitespace-nowrap">
                            {item?.transaction_by || "System"}
                          </td>
                          <td className="px-3 py-4 border  whitespace-nowrap">
                            {item?.createdAt}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="12"
                          className="py-4 text-base text-center text-gray-800"
                        >
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination controls */}
              <div className="flex items-center justify-between mt-4">
                <button
                  onClick={goToPreviousPage}
                  disabled={currentPage === 1}
                  className={`px-4 py-2 bg-blue-900 hover:bg-blue-800/50 text-white rounded ${
                    currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                >
                  Previous
                </button>
                <p className="text-lg text-gray-800">
                  Page {currentPage} of {totalPages}
                </p>
                <button
                  onClick={goToNextPage}
                  disabled={currentPage === totalPages}
                  className={`px-4 py-2 bg-blue-900 hover:bg-blue-800/50 text-white rounded ${
                    currentPage === totalPages
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                >
                  Next
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
